import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NeoUsuarioIntermediario } from '../models/NeoUserDTO';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';
@Injectable({
  providedIn: 'root'
})
export class BancoldexService {
  url: string = environment.apiLocalUrl;

  urlparametros: string = `${this.url}parametros/servicios`;

  urlmodificar: string = `${this.url}parametros/servicios`;

  constructor(private http: HttpClient) { }

  saveRistroApc(registroForm: any) {
    return this.http.post(`${this.url}bancoldex/servicios/administracion/intermediario/activacion/`, registroForm).pipe(catchError(HandleHttpError));
  }
  getUsuarioIntermediario(idUsuario, idUsuarioConsultor): Observable<any> {
    return this.http.get(
      this.url + '/bancoldex/servicios/administracion/intermediario/consultarUsuario/' + idUsuario + '/' + idUsuarioConsultor
    ).pipe(catchError(HandleHttpError));
  }
  getFilterParametro(body:any){
    return this.http.post(`${this.url}neoParametro/getFilter`,body).pipe(catchError(HandleHttpError));
  }
  getFilter(body:any){
    return this.http.post(`${this.url}bancoldex/servicios/administracion/getFilter`,body).pipe(catchError(HandleHttpError));
  }
  getDetalleParametro(idparametro){
    return this.http.get(`${this.url}neoParametro/${idparametro}`).pipe(catchError(HandleHttpError));
  }

  editarParametro(body:any){
    return this.http.post(`${this.url}neoParametro/update`,body).pipe(catchError(HandleHttpError));
}

  updateUsuarioBancoldex(usuarioDTO): Observable<any> {
    let body = JSON.stringify(usuarioDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post(`${this.url}bancoldex/servicios/administracion/usuario/modificacion` + '', body, { headers: headers }).pipe(catchError(HandleHttpError));
  }
  getSolicitudesPendientes() {
    return this.http.get(`${this.url}bancoldex/servicios/administracion/solicitudesPendientes`).pipe(catchError(HandleHttpError));
}
  getAutorizarSarlaf(body:any) {
    return this.http.post(`${this.url}bancoldex/servicios/solicitud/autorizarSarlaf`,body).pipe(catchError(HandleHttpError));
}
  getDenegarSarlaf(body:any) {
  return this.http.post(`${this.url}bancoldex/servicios/solicitud/devolverSarlaf`,body).pipe(catchError(HandleHttpError));
}

  uploadFile(body:any){
    return this.http.post(`${this.url}bancoldex/servicios/administracion/intermediario/guardarArchivos`, body).pipe(catchError(HandleHttpError));

  }
  getDocumentosFiles() {
    return this.http.get(`${this.urlparametros}/tiposDocumentos/registroapc`).pipe(catchError(HandleHttpError));
}

  saveUsuarioBancoldex(usuarioDTO): Observable<any> {
    let body = JSON.stringify(usuarioDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post(`${this.url}bancoldex/servicios/administracion/usuario/creacion` + '', body, { headers: headers }).pipe(catchError(HandleHttpError));

  }
  buscarUsuarioByIdentificador(identificador) {
    return this.http.get(`${this.url}bancoldex/servicios/administracion/usuario/bancoldex/${identificador}`).pipe(catchError(HandleHttpError));
  }
  buscarUsuarioByNumeroDocumento(idTipoDocIdentidad, numeroDocumento): Observable<any> {
    return this.http.get<NeoUsuarioIntermediario[]>(`${this.url}bancoldex/servicios/administracion/usuario/${idTipoDocIdentidad}/${numeroDocumento}`).pipe(catchError(HandleHttpError));
  }
  crearUsuarioBancoldex(usuarioDTO): Observable<any> {
    let body = JSON.stringify(usuarioDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post(`${this.url}bancoldex/servicios/administracion/usuario/bancoldex/creacion` + '', body, { headers: headers }).pipe(catchError(HandleHttpError));
  }
  buscarIntermediarioNit(nit: string) {
    return this.http.get(`${this.url}bancoldex/servicios/administracion/intermediario/busqueda/${nit}`).pipe(catchError(HandleHttpError));
  }

  getTipoDocumentos() {
    return this.http.get(`${this.urlparametros}/tipoDocIdentidad`).pipe(catchError(HandleHttpError));
  }

  buscarIntermedarioModificar(nit: string) {
    return this.http.get(`${this.url}bancoldex/servicios/administracion/intermediario/modificacion/busqueda/${nit}`).pipe(catchError(HandleHttpError));
  }

  getEstados() {
    return this.http.get(`${this.url}bancoldex/servicios/administracion/intermediario/estados`).pipe(catchError(HandleHttpError));
  }
  getAdmistradores(nit): Observable<any> {
    return this.http.get<NeoUsuarioIntermediario[]>(`${this.url}bancoldex/servicios/administracion/intermediario/administradores/${nit}`).pipe(catchError(HandleHttpError));
  }

  deleteAdmistrador(idUsuario): Observable<any> {
    return this.http.delete(`${this.url}bancoldex/servicios/administracion/intermediario/administrador/eliminacion/${idUsuario}`).pipe(catchError(HandleHttpError));
  }

  updateAPC(neousuarioDTO: any): Observable<any> {
    let body = JSON.stringify(neousuarioDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post(`${this.url}bancoldex/servicios/administracion/intermediario/administrador/modificacion` + '', body, { headers: headers }).pipe(catchError(HandleHttpError));
  }
  deleteFile(idDocumento: string){
    return this.http.get(`${this.url}bancoldex/administracion/intermediario/eliminarDocumento/{idDocumentoSolicitud}/${idDocumento}`).pipe(catchError(HandleHttpError));
  }
  updateIntermediario(clienteDTO): Observable<any> {
    let body = JSON.stringify(clienteDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post(`${this.url}bancoldex/servicios/administracion/intermediario/modificacion/` + '', body, { headers: headers }).pipe(catchError(HandleHttpError));
  }

  crearRegistroAdmistrador(usuarioDTO): Observable<any> {
    let body = JSON.stringify(usuarioDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post(`${this.url}bancoldex/servicios/administracion/intermediario/administrador/creacion` + '', body, { headers: headers }).pipe(catchError(HandleHttpError));
  }

  crearAdmistrador(registroForm: any) {
    return this.http.post(`${this.url}bancoldex/servicios/administracion/intermediario/administrador/creacion`, registroForm).pipe(catchError(HandleHttpError));
  }

  crearCliente(registroForm: any) {
    return this.http.post(`${this.url}bancoldex/servicios/administracion/intermediario/creacion`, registroForm).pipe(catchError(HandleHttpError));
  }

  //By Andres Puello

  login(body: any) {
    return this.http.post(`${this.url}bancoldex/servicios/ingreso`, body).pipe(catchError(HandleHttpError));
  }

  getIndicadores() {
    return this.http.get(`${this.url}bancoldex/servicios/estadisticas`).pipe(catchError(HandleHttpError));
  }

  getTaks(body: any) {
    return this.http.post(`${this.url}bancoldex/servicios/tareas`, body).pipe(catchError(HandleHttpError));
  }

  aprobarPropuesta(body: any) {
    return this.http.post(`${this.url}bancoldex/servicios/solicitud/autorizar`, body).pipe(catchError(HandleHttpError));
  }

  devolverPropuesta(body: any) {
    return this.http.post(`${this.url}bancoldex/servicios/solicitud/devolver`, body).pipe(catchError(HandleHttpError));
  }

  getDevoluciones() {
    return this.http.get(`${this.urlparametros}/tiposDevolucion`).pipe(catchError(HandleHttpError));
  }

  //mensajes informativos
  getMensajesInformativos() {
    return this.http.get(`${this.url}bancoldex/servicios/mensajesInformativos`).pipe(catchError(HandleHttpError));
  }

  crearMensajeInformativo(mensajeInformativo) {
    let body = JSON.stringify(mensajeInformativo);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post(this.url + 'bancoldex/servicios/crearMensajeInformativo', body, {headers: headers,}).pipe(catchError(HandleHttpError));
  }

  getMensajeInformativo(idMensajeInformativo) {
    return this.http.get(`${this.url}bancoldex/servicios/mensajeInformativo/${idMensajeInformativo}`).pipe(catchError(HandleHttpError));
  }

  deleteMensajeInformativo(idMensajeInformativo): Observable<any> {
    return this.http.delete(`${this.url}bancoldex/servicios/borrarMensajeInformativo/${idMensajeInformativo}`).pipe(catchError(HandleHttpError));
  }

  getDesbloquearUsuario(idUsuario) {
    return this.http.get(`${this.url}bancoldex/servicios/administracion/usuario/desbloquear/${idUsuario}`).pipe(catchError(HandleHttpError));
  }

  getBuscarUsuarios(body:any) {
    return this.http.post(this.url + 'bancoldex/servicios/administracion/usuario/bloqueado/', body).pipe(catchError(HandleHttpError));
  }

  //mensajes notificacion
  getMensajesNotificacion() {
    return this.http.get(`${this.url}bancoldex/servicios/mensajesNotificacion`).pipe(catchError(HandleHttpError));
  }

  crearMensajeNotificacion(mensajeNotificacion) {
    let body = JSON.stringify(mensajeNotificacion);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post(this.url + 'bancoldex/servicios/crearMensajeNotificacion', body, {headers: headers,}).pipe(catchError(HandleHttpError));
  }

  getMensajeNotificacion(idMensajeNotificacion) {
    return this.http.get(`${this.url}bancoldex/servicios/mensajeNotificacion/${idMensajeNotificacion}`).pipe(catchError(HandleHttpError));
  }

  deleteMensajeNotificacion(idMensajeNotificacion): Observable<any> {
    return this.http.delete(`${this.url}bancoldex/servicios/borrarMensajeNotificacion/${idMensajeNotificacion}`).pipe(catchError(HandleHttpError));
  }

  consultarPerfilesBancoldex(body:any){
    return this.http.post(`${this.url}bancoldex/servicios/consultarPerfilesBancoldex`, body).pipe(catchError(HandleHttpError));
  }

  dowloadExcelPerfiles(body: any){
    return this.http.post(`${this.url}bancoldex/servicios/generarExcelConsultaPerfiles`,body).pipe(catchError(HandleHttpError));
  }

  dowloadTxtPerfiles(body: any){
    return this.http.post(`${this.url}bancoldex/servicios/generarTxtConsultaPerfiles`,body).pipe(catchError(HandleHttpError));
  }

  consultarRolesNoUtilizados(body:any):Observable<any>{
    return this.http.post(`${this.url}bancoldex/servicios/consultaRolesNoUtilizadosBcdx`,body).pipe(catchError(HandleHttpError));
  }

  dowloadExcelRolesNoUtilizados(body:any){
    return this.http.post(`${this.url}bancoldex/servicios/descargarExcelRolesNoUtilizados`,body).pipe(catchError(HandleHttpError));
  }

  dowloadTxtRolesNoUtilizados(body:any){
    return this.http.post(`${this.url}bancoldex/servicios/descargarTxtRolesNoUtilizados`,body).pipe(catchError(HandleHttpError));
  }

  filtarIndicadores(datosFiltrar) {
    let body = JSON.stringify(datosFiltrar);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post(this.url + 'bancoldex/servicios/administracion/filtrarIndicadores', body, {headers: headers,}).pipe(catchError(HandleHttpError));
  }

  intermediariosNegacion(datosFiltrar) {
    let body = JSON.stringify(datosFiltrar);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post(this.url + 'bancoldex/servicios/administracion/intermediariosNegacion', body, {headers: headers,}).pipe(catchError(HandleHttpError));
  }

  getSolicitudes(idCuentaCobro) {
    return this.http.get(`${this.url}bancoldex/servicios/cuentasCobroPorSolicitud/${idCuentaCobro}`);
  }

  getArchivosBannerActivos(banner:string){
    return this.http.get(`${this.url}bancoldex/servicios/banner/bannersActivos/${banner}`);
  }

  getArchivosBannerOrderByNameAliados(tipoBanner:string){
    return this.http.get(`${this.url}bancoldex/servicios/banner/bannersAliados/${tipoBanner}`)
    .pipe(catchError(HandleHttpError));
  }

  getArchivosBannerOrderByNameAliadosC(tipoBanner:string){
    return this.http.get(`${this.url}bancoldex/servicios/banner/bannersAliadosComerciales/${tipoBanner}`)
    .pipe(catchError(HandleHttpError));
  }
   // grupos por tipo documento

  getGrupoTipoDocumetos(documento:string){
    return this.http.get(`${this.url}neoGrupoTipoDocumento/servicios/tipo-documento/${documento}`);
  }

  getDeshabilitarUsuario(datosAut) {

      let body = JSON.stringify(datosAut);
      let headers = new HttpHeaders().set('Content-type', 'application/json');
      return this.http.post(this.url + 'bancoldex/servicios/administracion/usuario/deshabilitarUsuarioEmpresario', body, {headers: headers,}).pipe(catchError(HandleHttpError));
  }

  addArchivoBanner(archivo: any){
    return this.http.post(`${this.url}bancoldex/servicios/banner/guardarBanner`,archivo).pipe(catchError(HandleHttpError));
  }

  getVideoEncuestaByIdSolicitud(idSolicitud:string){
    return this.http.get(`${this.url}bancoldex/servicios/banner/videoEncuesta/${idSolicitud}`).pipe(catchError(HandleHttpError));
  }

  deleteArchivoBanner(idBanner:number){
    return this.http.delete(`${this.url}bancoldex/servicios/banner/borrarBanner/${idBanner}`).pipe(catchError(HandleHttpError));
  }
}